import { render, staticRenderFns } from "./OrderMall.vue?vue&type=template&id=4645eec0&scoped=true"
import script from "./OrderMall.vue?vue&type=script&lang=ts"
export * from "./OrderMall.vue?vue&type=script&lang=ts"
import style0 from "./OrderMall.vue?vue&type=style&index=0&id=4645eec0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4645eec0",
  null
  
)

export default component.exports